const GENERATING = 13
const SUCCESSFULLY_GENERATED = 14
const FAILED_GENERATION = 15


export default {
    GENERATING,
    SUCCESSFULLY_GENERATED,
    FAILED_GENERATION
}